import { create } from 'zustand';

/**
 * Saf UI durumu: hangi panel açık, mobil menü, arama katmanı.
 * Sunucu verisi burada YAŞAMAZ.
 */
export type OverlayName = 'cart' | 'search' | 'mobileMenu' | 'filters' | null;

interface UiState {
  overlay: OverlayName;
  openOverlay: (name: Exclude<OverlayName, null>) => void;
  closeOverlay: () => void;
  toggleOverlay: (name: Exclude<OverlayName, null>) => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  overlay: null,
  openOverlay: (name) => set({ overlay: name }),
  closeOverlay: () => set({ overlay: null }),
  toggleOverlay: (name) =>
    set({ overlay: get().overlay === name ? null : name }),
}));
